var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2080 2325.5",
    style: {
      enableBackground: "new 0 0 2080 2325.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#656565;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{opacity:0.444;fill:url(#SVGID_3_);enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.1,1988.2c0-92.2-26.3-138.2-79-139.9c-21.4-1.6-41.1,3.3-60.9,9.9c-16.5,4.9-26.3,11.5-31.3,16.5v217.2 c32.9,21.4,62.5,31.3,88.9,29.6C199.1,2116.5,227.1,2072.1,227.1,1988.2z M291.3,1991.5c0,46.1-9.9,83.9-32.9,115.2 c-24.7,34.6-57.6,52.7-102,52.7c-32.9,1.6-65.8-9.9-100.4-31.3v197.5L0,2305.8v-439.4c9.9-11.5,21.4-21.4,34.6-29.6 c32.9-19.7,74.1-29.6,120.1-29.6c42.8,0,77.3,18.1,100.4,52.7C279.7,1897.7,291.3,1938.8,291.3,1991.5L291.3,1991.5z M631.9,2121.5 c0,62.5-6.6,105.3-18.1,128.4c-13.2,23-36.2,42.8-70.8,57.6c-29.6,11.5-59.2,18.1-92.2,18.1l-9.9-34.6c34.6-4.9,57.6-9.9,70.8-13.2 c26.3-9.9,46.1-23,55.9-42.8c8.2-14.8,11.5-44.4,11.5-87.2V2133c-37.8,18.1-79,26.3-120.1,26.3c-28,0-52.7-8.2-72.4-26.3 c-23-18.1-34.6-42.8-34.6-72.4v-232l55.9-19.7v233.7c0,24.7,8.2,44.4,24.7,57.6c16.5,13.2,36.2,19.7,62.5,19.7 c26.3,0,52.7-9.9,82.3-29.6V1817h55.9L631.9,2121.5z M849.1,2157.7H831c-31.3,0-55.9-8.2-74.1-23c-18.1-14.8-26.3-36.2-26.3-62.5 v-220.5h-37.8V1817h37.8v-93.8l55.9-19.7V1817h62.5v34.6h-62.5v217.2c0,21.4,4.9,36.2,16.5,44.4c9.9,6.6,24.7,11.5,46.1,13.2 L849.1,2157.7z M1188.1,2152.7h-55.9v-215.6c0-21.4-4.9-41.1-14.8-55.9c-11.5-18.1-28-26.3-49.4-26.3c-26.3,0-57.6,13.2-95.4,41.1 v258.4h-55.9v-515.1l55.9-18.1v233.7c36.2-26.3,74.1-39.5,116.8-39.5c29.6,0,52.7,9.9,72.4,29.6c18.1,19.7,28,44.4,28,74.1 L1188.1,2152.7z M1484.3,1978.3c0-34.6-6.6-64.2-19.7-87.2c-16.5-28-39.5-42.8-74.1-44.4c-60.9,3.3-92.2,47.7-92.2,131.6 c0,39.5,6.6,70.8,19.7,97.1c16.5,32.9,41.1,49.4,74.1,49.4C1453,2123.1,1484.3,2075.4,1484.3,1978.3z M1545.2,1978.3 c0,49.4-13.2,92.2-37.8,125.1c-28,36.2-67.5,55.9-115.2,55.9c-49.4,0-87.2-18.1-115.2-55.9c-24.7-32.9-37.8-74.1-37.8-125.1 c0-47.7,13.2-87.2,41.1-118.5c29.6-34.6,65.8-51,111.9-51s83.9,16.5,113.5,51C1532,1892.7,1545.2,1932.2,1545.2,1978.3z  M1866.1,2152.7h-55.9v-227.1c0-24.7-8.2-44.4-23-57.6c-14.8-13.2-34.6-21.4-60.9-19.7c-26.3,0-52.7,9.9-75.7,26.3V2156h-55.9v-288 c31.3-23,60.9-39.5,88.9-46.1c26.3-6.6,47.7-9.9,67.5-9.9c13.2,0,26.3,1.6,37.8,3.3c21.4,4.9,39.5,14.8,52.7,28 c14.8,14.8,23,34.6,23,55.9L1866.1,2152.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12914.6377,
    y1: -27007.6797,
    x2: 12991.0264,
    y2: -27073.4023,
    gradientTransform: "matrix(9.2563 0 0 -9.3468 -119299.5781 -252400.0313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CA0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#316A99"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M908.4,0.3c-52.7,0-103.7,4.9-148.1,13.2c-131.6,23-154.7,70.8-154.7,161.3v118.5h309.4v39.5H490.4 c-88.9,0-167.8,54.3-192.5,156.3c-28,118.5-29.6,190.9,0,314.3c21.4,92.2,74.1,156.3,164.6,156.3h107V818.2 c0-102,88.9-192.5,192.5-192.5h307.7c85.6,0,154.7-70.8,154.7-158V173.1c0-83.9-70.8-146.5-154.7-161.3 C1015.3,3.6,961-1.3,908.4,0.3z M740.5,94.1c31.3,0,57.6,26.3,57.6,59.2s-26.3,59.2-57.6,59.2c-31.3,0-57.6-26.3-57.6-59.2 S707.6,94.1,740.5,94.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 13020.6973,
    y1: -27113.1328,
    x2: 12993.4189,
    y2: -27074.5391,
    gradientTransform: "matrix(9.2563 0 0 -9.3468 -119299.5781 -252400.0313)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD43E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE975"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1262.2,329.4V466c0,107-90.5,195.8-194.2,195.8H760.3c-83.9,0-154.7,72.4-154.7,158v294.6 c0,83.9,72.4,133.3,154.7,158c97.1,29.6,190.9,34.6,309.4,0c77.3-23,154.7-67.5,154.7-158V995.9H914.9v-39.5H1379 c88.9,0,123.4-62.5,154.7-156.3c32.9-97.1,31.3-189.2,0-314.3c-21.4-88.9-64.2-156.3-154.7-156.3L1262.2,329.4z M1087.7,1074.9 c31.3,0,57.6,26.3,57.6,59.2s-26.3,59.2-57.6,59.2c-31.3,0-57.6-26.3-57.6-59.2S1056.5,1074.9,1087.7,1074.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1973,1767.7h9.9v-60.9h23v-8.2H1950v8.2h23V1767.7z M2015.8,1767.7h8.2v-55.9l18.1,55.9h9.9l18.1-55.9v55.9 h9.9v-69.1h-11.5l-21.4,59.2l-18.1-59.2h-13.2L2015.8,1767.7z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -83039.6641,
    cy: -13866.3984,
    r: 20.3396,
    gradientTransform: "matrix(0 -3.9477 -17.3558 0 -239744.5313 -326357.7188)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8B8B8",
      stopOpacity: 0.498
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7F8080",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1332.9,1471.5c0,44.4-185.9,80.6-414.7,80.6s-414.7-36.2-414.7-80.6c0-44.4,185.9-80.6,414.7-80.6 S1332.9,1427,1332.9,1471.5L1332.9,1471.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython4);
export default __webpack_public_path__ + "static/media/python-4.e9751126997d33712a95df5e19fe2d58.svg";
export { ForwardRef as ReactComponent };